/**
 * Capability-map React Query hooks (P85.2).
 *
 * Mirrors GET /v1/twin/capability-graph from P85.1. Cascade
 * impact data continues to come from useCascade (existing).
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import { capabilityGraphKeys } from "shared/api/queryClient";
import type { CapabilityGraph } from "shared/api/types";

export function useCapabilityGraph(
  opts: { as_of?: string | null } = {},
): UseQueryResult<CapabilityGraph, ApiError> {
  const asOf = opts.as_of ?? null;
  return useQuery({
    queryKey: capabilityGraphKeys.query({ as_of: asOf }),
    queryFn: () =>
      api.get<CapabilityGraph>(
        asOf
          ? `/v1/twin/capability-graph?as_of=${encodeURIComponent(asOf)}`
          : "/v1/twin/capability-graph",
      ),
  });
}
